import { useState, useMemo } from "react";
import { NumberField, Stat, Donut, ToolShell } from "./parts";
import { calcEmi, inr, inrShort } from "@/lib/format";

export function EmiCalculator() {
  const [amount, setAmount] = useState(5000000);
  const [rate, setRate] = useState(8.5);
  const [years, setYears] = useState(20);

  const { emi, totalInterest, total } = useMemo(() => {
    const emi = calcEmi(amount, rate, years);
    const total = emi * years * 12;
    return { emi, totalInterest: total - amount, total };
  }, [amount, rate, years]);

  return (
    <ToolShell title="EMI Calculator" desc="Estimate your monthly home-loan instalment and see exactly how much interest you'll pay over the tenure.">
      <div className="grid gap-10 lg:grid-cols-2">
        <div className="space-y-8">
          <NumberField label="Loan Amount" value={amount} onChange={setAmount} min={500000} max={100000000} step={100000} prefix="₹" testid="emi-amount" />
          <NumberField label="Interest Rate (p.a.)" value={rate} onChange={setRate} min={5} max={18} step={0.05} suffix="%" testid="emi-rate" />
          <NumberField label="Tenure" value={years} onChange={setYears} min={1} max={30} step={1} suffix="yrs" testid="emi-tenure" />
        </div>
        <div className="space-y-5">
          <Stat label="Monthly EMI" value={inr(emi)} highlight testid="emi-result" />
          <div className="grid grid-cols-2 gap-3">
            <Stat label="Principal" value={inrShort(amount)} />
            <Stat label="Total Interest" value={inrShort(totalInterest)} />
          </div>
          <Stat label="Total Payable" value={inrShort(total)} />
          <Donut data={[{ name: "Principal", value: amount }, { name: "Interest", value: totalInterest }]} />
        </div>
      </div>
    </ToolShell>
  );
}
